package app

class HistoryState<T>(initial: T) {
    private val snapshots = mutableListOf(initial)
    private var index = 0

    val current: T
        get() = snapshots[index]

    val canUndo: Boolean
        get() = index > 0

    val canRedo: Boolean
        get() = index < snapshots.lastIndex

    fun push(value: T): T {
        while (snapshots.lastIndex > index) {
            snapshots.removeAt(snapshots.lastIndex)
        }
        snapshots.add(value)
        index = snapshots.lastIndex
        return current
    }

    fun undo(): T {
        if (canUndo) index -= 1
        return current
    }

    fun redo(): T {
        if (canRedo) index += 1
        return current
    }

    fun reset(value: T): T {
        snapshots.clear()
        snapshots.add(value)
        index = 0
        return current
    }

    fun positionLabel(): String = "${index + 1}/${snapshots.size}"
}
